var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointer2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 151,
    viewBox: "0 0 147 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.983 129.949C135.542 140.244 125.486 154.672 110.276 146.398C103.049 142.467 99.8201 129.504 102.056 122.295C103.912 116.315 104.073 108.237 111.252 105.966C116.892 104.182 123.012 106.103 125.787 111.636C133.667 127.352 111.088 131.593 101.466 127.161C88.3332 121.112 80.6304 82.906 95.2557 74.9488C107.795 68.1263 111.132 84.0356 101.898 90.7708C88.9096 100.245 79.5108 98.3807 70.8134 82.8051C64.0224 70.6437 71.0156 53.7512 80.654 46.3004C82.6557 44.753 91.6532 32.7134 92.7203 34.3949C103.25 50.9866 74.2106 64.6983 61.3647 58.6593C46.6051 51.7205 31.7502 44.5314 24.4464 29.7666C20.5188 21.8268 16.0278 -4.27598 15.9654 4.58192C15.8872 15.6671 14.7695 30.6357 7.90121 40.0406C5.85748 42.8392 -0.452875 51.9335 5.18009 42.9876C10.9814 33.7745 16.306 25.7945 20.0825 16.168C20.9229 14.0258 18.8009 10.1882 18.2705 8.0719C17.8214 6.27943 23.8073 9.88589 24.5621 10.1528C31.0791 12.4572 37.8087 11.3548 44.3068 9.53466C50.1067 7.91009 57.2488 3.96021 60.6442 6.79476",
    stroke: "#00ADB5",
    strokeOpacity: 0.2,
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer2);
export default __webpack_public_path__ + "static/media/pointer2.fe5e4da59d1575fb65d78889a62a61cc.svg";
export { ForwardRef as ReactComponent };